"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditValidationComparisonsDto = instanceOfDocumentAuditValidationComparisonsDto;
exports.DocumentAuditValidationComparisonsDtoFromJSON = DocumentAuditValidationComparisonsDtoFromJSON;
exports.DocumentAuditValidationComparisonsDtoFromJSONTyped = DocumentAuditValidationComparisonsDtoFromJSONTyped;
exports.DocumentAuditValidationComparisonsDtoToJSON = DocumentAuditValidationComparisonsDtoToJSON;
exports.DocumentAuditValidationComparisonsDtoToJSONTyped = DocumentAuditValidationComparisonsDtoToJSONTyped;
const DocumentAuditDateComparisonDto_1 = require("./DocumentAuditDateComparisonDto");
const DocumentAuditNameComparisonDto_1 = require("./DocumentAuditNameComparisonDto");
/**
 * Check if a given object implements the DocumentAuditValidationComparisonsDto interface.
 */
function instanceOfDocumentAuditValidationComparisonsDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('dates' in value) || value['dates'] === undefined)
        return false;
    return true;
}
function DocumentAuditValidationComparisonsDtoFromJSON(json) {
    return DocumentAuditValidationComparisonsDtoFromJSONTyped(json, false);
}
function DocumentAuditValidationComparisonsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': (0, DocumentAuditNameComparisonDto_1.DocumentAuditNameComparisonDtoFromJSON)(json['name']),
        'dates': (json['dates'].map(DocumentAuditDateComparisonDto_1.DocumentAuditDateComparisonDtoFromJSON)),
    };
}
function DocumentAuditValidationComparisonsDtoToJSON(json) {
    return DocumentAuditValidationComparisonsDtoToJSONTyped(json, false);
}
function DocumentAuditValidationComparisonsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': (0, DocumentAuditNameComparisonDto_1.DocumentAuditNameComparisonDtoToJSON)(value['name']),
        'dates': (value['dates'].map(DocumentAuditDateComparisonDto_1.DocumentAuditDateComparisonDtoToJSON)),
    };
}
//# sourceMappingURL=DocumentAuditValidationComparisonsDto.js.map